export default "__VITE_ASSET__BzoErviO__"